import { render, staticRenderFns } from "./AttachFields.vue?vue&type=template&id=5ec31d90&"
import script from "./AttachFields.vue?vue&type=script&lang=js&"
export * from "./AttachFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports